import './index.css'
import React, { useRef } from 'react'

const ToolTip = ({ children, toolTipContent, customStyle = {}, ...rest }) => {
  const toolTipRef = useRef(null)

  const normalStyle = {
    backgroundColor: 'rgba(20, 40, 70, 0.9)',
    visibility: 'hidden',
    textAlign: 'center',
    paddgin: '2rem 1rem',
    borderRadius: '10px',
    position: 'absolute',
    bottom: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 4,
    width: '100%',
  }

  return (
    <div
      className="g-tooltip"
      onMouseOver={() => (toolTipRef.current.style.visibility = 'visible')}
      onMouseOut={() => (toolTipRef.current.style.visibility = 'hidden')}
    >
      <div ref={toolTipRef} style={{ ...normalStyle, ...customStyle }}>
        {toolTipContent()}
      </div>
      {children}
    </div>
  )
}

export default ToolTip
